
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Faut-il que votre entreprise soit présente sur Facebook ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les avantages et inconvénients d'une présence sur Facebook pour votre entreprise, et comment évaluer si ce réseau social est adapté à vos objectifs.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Votre entreprise doit-elle être présente sur Facebook ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous cherchez à gagner en visibilité sur la Toile ? Les Pages Facebook sont faites pour vous. À l’instar d’un site Internet esthétique et réactif, une landing page efficace ou encore une newsletter envoyée quotidiennement à vos clients, découvrez un puissant outil de communication pour votre entreprise.",
        },
      ],
    };
  },
};
